var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-885 -12170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(884.835 12169.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(0.165 0.284)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-instagram",
    "data-name": "Icon simple-instagram",
    d: "M11.871,0C8.646,0,8.243.015,6.977.071A8.753,8.753,0,0,0,4.1.623a5.813,5.813,0,0,0-2.1,1.369A5.792,5.792,0,0,0,.623,4.1,8.728,8.728,0,0,0,.071,6.977C.012,8.243,0,8.646,0,11.871S.015,15.5.071,16.765a8.759,8.759,0,0,0,.552,2.882,5.822,5.822,0,0,0,1.369,2.1,5.8,5.8,0,0,0,2.1,1.369,8.764,8.764,0,0,0,2.882.552c1.266.059,1.669.071,4.894.071s3.628-.015,4.894-.071a8.784,8.784,0,0,0,2.882-.552,6.067,6.067,0,0,0,3.472-3.472,8.759,8.759,0,0,0,.552-2.882c.059-1.266.071-1.669.071-4.894s-.015-3.628-.071-4.894A8.779,8.779,0,0,0,23.118,4.1a5.826,5.826,0,0,0-1.369-2.1,5.784,5.784,0,0,0-2.1-1.369A8.733,8.733,0,0,0,16.765.071C15.5.012,15.1,0,11.871,0Zm0,2.137c3.169,0,3.546.016,4.8.07a6.54,6.54,0,0,1,2.2.411A3.906,3.906,0,0,1,21.125,4.87a6.554,6.554,0,0,1,.409,2.2c.056,1.252.069,1.628.069,4.8s-.015,3.546-.073,4.8a6.68,6.68,0,0,1-.416,2.2,3.769,3.769,0,0,1-.889,1.367,3.7,3.7,0,0,1-1.365.886,6.6,6.6,0,0,1-2.211.409c-1.26.056-1.631.069-4.807.069s-3.547-.015-4.807-.073a6.731,6.731,0,0,1-2.212-.416,3.676,3.676,0,0,1-1.364-.889,3.6,3.6,0,0,1-.89-1.365,6.737,6.737,0,0,1-.415-2.211c-.045-1.246-.06-1.631-.06-4.792s.016-3.547.06-4.809a6.729,6.729,0,0,1,.415-2.21,3.519,3.519,0,0,1,.89-1.366,3.511,3.511,0,0,1,1.364-.888,6.57,6.57,0,0,1,2.2-.416c1.261-.045,1.632-.059,4.807-.059l.045.03Zm0,3.638a6.1,6.1,0,1,0,6.1,6.1A6.1,6.1,0,0,0,11.871,5.775Zm0,10.053a3.957,3.957,0,1,1,3.957-3.957A3.956,3.956,0,0,1,11.871,15.828ZM19.632,5.535a1.424,1.424,0,1,1-1.424-1.424A1.425,1.425,0,0,1,19.632,5.535Z",
    transform: "translate(15.079 15.079)",
    fill: "#2e2e2e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.8b8f666c049629f73f5447fa2e2fd12c.svg";
export { ForwardRef as ReactComponent };